import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationDashboardSummary = ({
  denominationId,
  startDate,
  endDate
}) => {
  if (startDate && endDate) {
    return axios.get(
      `/denominations/${denominationId}/dashboard-member-totals?start_date=${startDate}&end_date=${endDate}`
    );
  }

  return axios.get(`/denominations/${denominationId}/dashboard-member-totals`);
};

export const useDenominationDashboardSummary = ({
  config,
  denominationId,
  startDate,
  endDate
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "denomination-dashboard-summary",
      denominationId,
      startDate,
      endDate
    ],
    queryFn: () =>
      getDenominationDashboardSummary({ denominationId, startDate, endDate }),
    enabled: !!denominationId,
    select: data => data.result
  });
};
